module.exports = __webpack_public_path__ + "img/hrb_xx@2x.1989e63d.png";